import Button from "components/base/Button";
import { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const SortItemsView = ({ originalItems, onSave, rowView }) => {
  const [items, setItems] = useState(
    originalItems.map((item, index) => ({
      ...item,
      _initialIndexNumber: item.indexNumber ?? index + 1,
    })),
  );

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  function onDragEnd(result) {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;
    const newItems = reorder(
      items,
      result.source.index,
      result.destination.index,
    );
    setItems(newItems);
  }

  return (
    <div className="text-sm">
      <div className="text-xs opacity-70 mt-2">
        Drag and Drop to set the ordering for these items.
      </div>
      <div className="mt-4">
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable-plans">
            {(provided) => {
              return (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {items.map((i, index) => (
                    <Draggable key={i.id} draggableId={i.id} index={index}>
                      {(provided, snapshot) => {
                        if (snapshot.isDragging) {
                          provided.draggableProps.style = {
                            ...provided.draggableProps.style,
                            left: provided.draggableProps.style.offsetLeft,
                            top: provided.draggableProps.style.offsetTop,
                          };
                        }
                        return (
                          <div
                            className="py-2"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <div className="card-in-modal flex items-center space-x-4">
                              <div className="w-5 h-5 bg-teal-600 text-white text-xs rounded-full flex items-center justify-center">
                                {i._initialIndexNumber}
                              </div>
                              {rowView(i)}
                            </div>
                          </div>
                        );
                      }}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </DragDropContext>
      </div>

      <hr />

      <div>
        <Button
          primary
          onClick={() =>
            onSave(
              items.map(({ _initialIndexNumber, ...item }) => item),
            )
          }
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default SortItemsView;
